import getConfig from 'next/config';
import isServer from './isServer';

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

export const API_ENDPOINT = isServer()
  ? serverRuntimeConfig.apiUrl
  : publicRuntimeConfig.apiUrl;
